export default __webpack_public_path__ + "static/media/edit-black.fef6395d.svg";